import { Http } from '../http/http';
import { SearchResult } from '../store/search';
import { ApiResult } from '../types/api-result';
import { ApiUrl, UrlParamBuilder } from './api-urls';

class SearchApi {
    public static async search(serviceProviderGroupId: string, query: string): Promise<ApiResult<SearchResult[]>> {
        const data = await Http.post<SearchParameters, SearchResult[]>(
            ApiUrl.Search,
            { searchText: query },
            new UrlParamBuilder().addServiceProviderGroupId(serviceProviderGroupId.toString()).build(),
        );
        return { data };
    }
}

interface SearchParameters {
    searchText: string;
}

export default SearchApi;
